declare var Ext: any;
declare var SyncManager: any;
declare var alert: Function;
declare var Date: any; // Figure out something, we use convertToUtc on date object:(

import 'cordova-plugin-purchase';

import {
    PurchasePluginBridge,
    EnrichedStoreProduct,
    IPoweredNowPurchaseRecord,
    IPoweredNowConsmuptionExtraRecord,
} from './PurchasePluginBridge';
import * as moment from 'moment';

export interface IAndroidTransaction extends CdvPurchase.Transaction {
    id: string;
    purchaseToken: string;
    purchaseState: number;
    receipt: string;
    signature: string;
    orderId: string;
    packageName: string;
    productId: string;
    purchaseTime: number;
    autoRenewing: boolean;
    acknowledged: boolean;
}

export default class PurchasePluginBridgeAndroid extends PurchasePluginBridge {
    protected static get platform() { return window?.CdvPurchase?.Platform?.GOOGLE_PLAY }

    protected hasExistingPurchaseRecordForTransaction(transaction: CdvPurchase.Transaction) {
        if (transaction) {
            const purchasesStore = Ext.getStore('Purchases');
            const productIds = transaction.products.map(product => product.id);
            const existingPurchaseRecord = purchasesStore.findRecordByFilterFn((purchaseRecord: IPoweredNowPurchaseRecord) => {
                return purchaseRecord.order_id === transaction.transactionId && productIds.includes(purchaseRecord.product);
            });

            return Boolean(existingPurchaseRecord);
        }
        return false;
    }

    protected getPoweredNowPurchaseRecord(verifiedReceipt: CdvPurchase.VerifiedReceipt): IPoweredNowPurchaseRecord {
        const lastTransaction = verifiedReceipt.sourceReceipt.lastTransaction();
        const product = this.store.get(lastTransaction.products[0].id); // This is not the best, but I don't know how we can end up having multiple products in the same transaction
        const enrichedStoreProduct = PurchasePluginBridge.enrichProductData(product);
        const purchaseDate = moment.utc(lastTransaction.purchaseDate);
        const expiryDate = moment.utc(lastTransaction.purchaseDate).add(moment.duration(product.pricing.billingPeriod))

        return {
            dt_created: purchaseDate.format('YYYY-MM-DD HH:mm:ss'),
            product: enrichedStoreProduct.id,
            transactionid: lastTransaction.transactionId,
            // @ts-ignore undocumented
            receipt: lastTransaction?.nativePurchase?.receipt,
            order_id: lastTransaction.purchaseId,
            quantity: 1,
            original_transaction_id: lastTransaction.transactionId,
            transaction_id: lastTransaction.transactionId,
            expires_date: expiryDate.format('YYYY-MM-DD hh:mm:ss'),
            purchase_date: purchaseDate.format('YYYY-MM-DD hh:mm:ss'),
            original_purchase_date: purchaseDate.format('YYYY-MM-DD hh:mm:ss'),
            purchase_origin: 2,
            purchase_currency: enrichedStoreProduct.currency,
            purchase_amount: enrichedStoreProduct.priceDecimal,
            original_price: String(enrichedStoreProduct.priceDecimal),
        };
    }

    protected getPoweredNowConsumptionExtraRecord(verifiedReceipt: CdvPurchase.VerifiedReceipt): IPoweredNowConsmuptionExtraRecord {
        const lastTransaction = verifiedReceipt.sourceReceipt.lastTransaction();
        const product = this.store.get(lastTransaction.products[0].id); // This is not the best, but I don't know how we can end up having multiple products in the same transaction
        const purchaseSetup = this.getPurchaseSetupRecordForProduct(product);
        const enrichedStoreProduct = PurchasePluginBridge.enrichProductData(product);
        const purchaseDate = moment.utc(lastTransaction.purchaseDate);
        const daysBeforeExpire = purchaseSetup.data.days_before_expires;
        const expiryDate = moment.utc(lastTransaction.purchaseDate).add(daysBeforeExpire, 'day');
        const type = this.getConsumptionExtraType(product);
        return {
            type,
            product: enrichedStoreProduct.product_id,
            count: purchaseSetup.data[type],
            quantity: 1,
            dt_created: purchaseDate.format('YYYY-MM-DD HH:mm:ss'),
            purchase_date: purchaseDate.format('YYYY-MM-DD HH:mm:ss'),
            expires_date: expiryDate.format('YYYY-MM-DD HH:mm:ss'),
            isverified: 0,
            order_id: lastTransaction.purchaseId,
            original_price: String(enrichedStoreProduct.priceDecimal),
            // @ts-ignore undocumented
            receipt: lastTransaction?.nativePurchase?.receipt,
            transaction_id: lastTransaction.transactionId,
            purchase_origin: 2,
            purchase_currency: enrichedStoreProduct.currency,
            purchase_amount: enrichedStoreProduct.priceDecimal,
        };
    }
}
